import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../shared/icons';
import Sifra from '../../../../../shared/components/Sifra';
import { useTranslation } from 'react-i18next';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  isLoading,
  openMasine,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          openMasine={() => openMasine(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    {
      field: 'nazivFirme',
      headerName: t('companyName'),
      width: 200,
      renderCell: (e) => (
        <Sifra displayValue={e.value} onClick={() => handleEditData(e.row)} />
      ),
    },
    { field: 'adresa', headerName: t('adress'), width: 150 },
    { field: 'kontaktTelefon', headerName: t('contactTel'), width: 150 },
    { field: 'email', headerName: t('email'), width: 200 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
};

export default GridProvider;
